export default function themeOptions() {
	console.log( 'Component Loaded' );
}